export default "__VITE_ASSET__DvlN8Var__"